import { Component } from '@angular/core';

@Component({
  selector: 'app-cta-section-redesign',
  templateUrl: './cta-section-redesign.component.html',
  styleUrls: ['./cta-section-redesign.component.scss']
})
export class CtaSectionRedesignComponent {

}
